const timestampIndexReducer = (state =0, action) => {
  switch(action.type) {
    case 'TIMESTAMP_CHANGED':
      return action.payload;
    default:
      return state
    }
  }

export default timestampIndexReducer;